// extracted by mini-css-extract-plugin
export default {"footer":"footer__lqHNM","footer__element":"footer__element__xADir","footer__element_link":"footer__element_link__A6iH0","footer__element_text":"footer__element_text__W3nct"};